import Text from '@atoms/Text';
import React from 'react';
import texts from './en.json';
import LazyImage from '@atoms/LazyImage';

export const ProductRisk = ({ productRisk }) => {
    const { cards } =
        productRisk || {};

    const ProductRiskCard = ({ description, icon }) => {
        return (
            <div className="flex flex-row md:flex-col xl:flex-row items-center gap-x-4 px-4 md:px-8 py-6 rounded-2xl bg-primary-10 backdrop-blur-md basis-full">

                <LazyImage src={icon} className="h-10 md:h-14 w-10 md:w-14 relative" />

                <Text
                    content={description}
                    className="p4-regular text-basicBlack md:text-center xl:text-left md:mt-6 xl:mt-0"
                />

            </div>
        );
    };
    return (
        <div id="product-risk-process" className='px-4 md:px-6 xl:px-18 py-6 flex flex-col items-center'>
            <div className='flex'>
                <Text content={`${texts.riskMitigation} `} className="whitespace-pre p3-regular md:h3-regular text-basicBlack" htmlTag='h2' />
                <Text content={`${texts.factors} `} className="p3-semibold md:h3-semibold text-basicBlack" htmlTag='h2' />
            </div>
            <div className='w-full mt-6 xl:mt-8 flex flex-col md:flex-row md:justify-between gap-6'>
                {cards?.map(({ description, icon }, index) =>
                    <ProductRiskCard description={description} icon={icon} key={index} />)
                }
            </div>
        </div>
    );
};
